import React from 'react';
import { IIconProps } from './IIconProps';

export const TrashBinIcon = ({
	iconClass = '',
	title = '',
	onClick,
	pointer,
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 24"
			className={`${iconClass} ${pointer ? 'icon--pointer' : ''}`}
			fill="none"
			onClick={onClick}
		>
			{title && <title>{title}</title>}
			<path d="M5 7H6.55556H19" className="trash-icon-top" />
			<mask id="path-3-inside-1" fill="white">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.5996 7.19998V18.4C17.5996 19.2836 16.8961 20 16.0282 20H8.17104C7.30316 20 6.59961 19.2836 6.59961 18.4V7.19998M8.95714 7.2V5.6C8.95714 4.71634 9.66069 4 10.5286 4H13.6714C14.5393 4 15.2428 4.71634 15.2428 5.6V7.2"
				/>
			</mask>
			<path
				d="M16.5996 7.19998V18.4H18.5996V7.19998H16.5996ZM16.5996 18.4C16.5996 18.7484 16.3269 19 16.0282 19V21C17.4653 21 18.5996 19.8189 18.5996 18.4H16.5996ZM16.0282 19H8.17104V21H16.0282V19ZM8.17104 19C7.87236 19 7.59961 18.7484 7.59961 18.4H5.59961C5.59961 19.8189 6.73397 21 8.17104 21V19ZM7.59961 18.4V7.19998H5.59961V18.4H7.59961ZM9.95714 7.2V5.6H7.95714V7.2H9.95714ZM9.95714 5.6C9.95714 5.25157 10.2299 5 10.5286 5V3C9.09149 3 7.95714 4.18112 7.95714 5.6H9.95714ZM10.5286 5H13.6714V3H10.5286V5ZM13.6714 5C13.9701 5 14.2428 5.25157 14.2428 5.6H16.2428C16.2428 4.18112 15.1085 3 13.6714 3V5ZM14.2428 5.6V7.2H16.2428V5.6H14.2428Z"
				className="trash-icon-bottom"
				mask="url(#path-3-inside-1)"
			/>
		</svg>
	);
};
